import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as EditIcon } from './edit_story_icon.svg';

export default function EditStoryIcon(props: SvgIconProps) {
  return <SvgIcon {...props} component={EditIcon} />;
}
